

window.addEventListener('DOMContentLoaded', () => {
    console.log('Custom JS loaded');

    //---------------------- Header ----------------------//
    const $headerGroup = document.getElementById('header-group');

    function updateHeaderOffset() {
        if (!$headerGroup) return;
        document.documentElement.style.setProperty('--header-offset', `${$headerGroup.offsetHeight}px`);
    }

    if ($headerGroup) {
        updateHeaderOffset();
        window.addEventListener('resize', updateHeaderOffset);
    }

    // Hide the header when scrolling down, reveal it as soon as the user scrolls back up
    if ($headerGroup) {
        let lastScrollY = Math.max(window.scrollY, 0);
        const scrollThreshold = 10; // ignore tiny scroll jitter

        window.addEventListener('scroll', () => {
            // Don't hide the header out from under an open mobile menu
            if (document.querySelector('.mobile-menu.open')) return;

            const currentScrollY = Math.max(window.scrollY, 0);
            const scrollDelta = currentScrollY - lastScrollY;

            if (Math.abs(scrollDelta) < scrollThreshold) return;

            const scrollingDown = scrollDelta > 0;
            const pastHeader = currentScrollY > $headerGroup.offsetHeight;

            $headerGroup.classList.toggle('header-group--hidden', scrollingDown && pastHeader);

            lastScrollY = currentScrollY;
        }, { passive: true });
    }
    //---------------------------------------------------//


    //------------------ Video Carousel ------------------//
    //---------------------------------------------------//


    //---------------------- Homepage hero ----------------------//
    const $homepageHero = document.querySelector(".homepage-hero");

    if ($homepageHero){
        const $triggers = $homepageHero.querySelectorAll(".homepage-hero__image-trigger");
        const $images = $homepageHero.querySelectorAll(".homepage-hero__image-slide");
        const $symbols = $homepageHero.querySelectorAll(".homepage-hero__image-symbol");

        if ($homepageHero.dataset.carousel){
            if ($triggers && $images && $symbols){

                // -------------------- Autoplay logic -------------------- //
                let currentIndex = 0;
                let intervalId;

                function goToNext() {
                    currentIndex = (currentIndex + 1) % $triggers.length;
                    $triggers[currentIndex].click();
                }

                function startLoop() {
                    intervalId = setInterval(goToNext, 5000);
                }

                function resetLoop(index) {
                    currentIndex = index;
                    clearInterval(intervalId);
                    startLoop();
                }
                // -------------------------------------------------------- //

                $triggers.forEach(($currentTrigger, index) => {
                    $currentTrigger.addEventListener("click", () => {
                        // Reset autoplay when user interacts
                        resetLoop(index);

                        // Toggle trigger active state
                        $triggers.forEach($trigger => {
                            $trigger.classList.remove("active");
                        });
                        $currentTrigger.classList.add("active");

                        // Toggle image active state
                        $images.forEach($image => {
                            if ($currentTrigger.dataset.index == $image.dataset.index){
                                $image.classList.add("active");
                            } else {
                                $image.classList.remove("active");
                            }
                        });

                        // Toggle symbol active state
                        $symbols.forEach($symbol => {
                            if ($currentTrigger.dataset.index == $symbol.dataset.index){
                                $symbol.classList.add("active");
                            } else {
                                $symbol.classList.remove("active");
                            }
                        });
                    });
                });

                // Start autoplay once everything is ready
                startLoop();
            }
        }

    }

    //---------------------------------------------------//


    //------------------ Swiper Section ------------------//
    const $swiperSection = document.querySelector(".swiper-section");

    if ($swiperSection) {
        const $triggers = [...$swiperSection.querySelectorAll(".swiper-section-trigger")];
        const $textBlocks = $swiperSection.querySelectorAll(".swiper-section__text");
        const $imageBlocks = $swiperSection.querySelectorAll(".swiper-section__image");
        const $next = $swiperSection.querySelector(".swiper-section__next");
        const $prev = $swiperSection.querySelector(".swiper-section__prev");

        const totalSlides = $triggers.length;
        let currentIndex = 0;

        function goToSlide(index) {
            // wrap around
            currentIndex = (index + totalSlides) % totalSlides;

            // triggers
            $triggers.forEach((trigger, i) => {
                trigger.classList.toggle("active", i === currentIndex);
            });

            // text
            $textBlocks.forEach(text => {
                text.classList.toggle(
                    "active",
                    Number(text.dataset.index) === currentIndex
                );
            });

            // images
            $imageBlocks.forEach(image => {
                image.classList.toggle(
                    "active",
                    Number(image.dataset.index) === currentIndex
                );
            });
        }

        // trigger clicks
        $triggers.forEach((trigger, i) => {
            trigger.addEventListener("click", () => {
                goToSlide(i);
            });
        });

        // next / prev
        $next?.addEventListener("click", () => {
            goToSlide(currentIndex + 1);
        });

        $prev?.addEventListener("click", () => {
            goToSlide(currentIndex - 1);
        });

        goToSlide(0);
    }

    //---------------------------------------------------//

    //------------------ Us vs Them ------------------//
    document.querySelectorAll(".us-vs-them-section").forEach($usVsThem => {
        const $triggers = [...$usVsThem.querySelectorAll(".us-vs-them-trigger")];
        const $panels = [...$usVsThem.querySelectorAll(".us-vs-them-card__panel")];

        const totalPanels = $triggers.length;

        function goToPanel(index, focusTrigger) {
            index = (index + totalPanels) % totalPanels;

            $triggers.forEach((trigger, i) => {
                const isActive = i === index;
                trigger.classList.toggle("active", isActive);
                trigger.setAttribute("aria-selected", isActive ? "true" : "false");
                trigger.setAttribute("tabindex", isActive ? "0" : "-1");
                if (isActive && focusTrigger) trigger.focus();
            });

            $panels.forEach(panel => {
                panel.classList.toggle("active", Number(panel.dataset.index) === index);
            });
        }

        $triggers.forEach((trigger, i) => {
            trigger.addEventListener("click", () => {
                goToPanel(i, false);
            });

            trigger.addEventListener("keydown", event => {
                if (event.key === "ArrowRight" || event.key === "ArrowDown") {
                    event.preventDefault();
                    goToPanel(i + 1, true);
                } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
                    event.preventDefault();
                    goToPanel(i - 1, true);
                } else if (event.key === "Home") {
                    event.preventDefault();
                    goToPanel(0, true);
                } else if (event.key === "End") {
                    event.preventDefault();
                    goToPanel(totalPanels - 1, true);
                }
            });
        });
    });

    //---------------------------------------------------//

    //------------------ Testimonials ------------------//
    const $testimonials = document.querySelector(".testimonials-section");

    if ($testimonials){
        const slides = Array.from(document.querySelectorAll(".testimonials-slide"));
        const triggers = Array.from(document.querySelectorAll(".testimonials-section-trigger"));

        const prevBtn = document.querySelectorAll(".testimonial-swiper___prev");
        const nextBtn = document.querySelectorAll(".testimonial-swiper___next");

        if (!slides.length || !triggers.length) return;

        let current = 0; // starting index

        function showSlide(index) {
            current = index;

            slides.forEach((slide, i) => {
                slide.classList.toggle("active", i === current);
            });

            triggers.forEach((trigger, i) => {
                trigger.classList.toggle("active", i === current);
            });
        }

        // Trigger click events
        triggers.forEach((trigger, index) => {
            trigger.addEventListener("click", () => {
            showSlide(index);
            });
        });

        // Prev / Next logic
        prevBtn.forEach(button => {
            button?.addEventListener("click", () => {
                const newIndex = (current - 1 + slides.length) % slides.length;
                showSlide(newIndex);
            });
        });

        nextBtn.forEach(button => {
            button?.addEventListener("click", () => {
                const newIndex = (current + 1) % slides.length;
                showSlide(newIndex);
            });
            
        });

        // Initialize
        showSlide(0);
    }

    //------------------ PDP --------------------//
    const $productTemplate = document.querySelector(".product-template");

    if ($productTemplate){
        const $accordions = $productTemplate.querySelectorAll(".product-accordion");
        const variantInput = $productTemplate.querySelector('[data-variant-id]');
        const qtyInput = $productTemplate.querySelector('[data-quantity]');
        const qtyDisplay = $productTemplate.querySelector('[data-qty-display]');
        const priceDisplay = $productTemplate.querySelector('[data-price-display]');
        const subscriptionPriceDisplay = $productTemplate.querySelector('[data-subscription-price-display]');
        const sellingPlanInput = $productTemplate.querySelector('[data-selling-plan]');
        const purchaseRadios = $productTemplate.querySelectorAll('input[name="purchase_type"]');
        const subscriptionFrequency = $productTemplate.querySelector(".subscription-frequency");
        const addToCartTrigger = $productTemplate.querySelector(".add-to-cart");
        const atcRow = $productTemplate.querySelector('[data-atc-row]');
        const stickyAtc = $productTemplate.querySelector('[data-sticky-atc]');
        const stickyAtcButton = $productTemplate.querySelector('[data-sticky-atc-button]');
        const stickyAtcPrice = $productTemplate.querySelector('[data-sticky-atc-price]');
        const atcPrice = $productTemplate.querySelector('[data-atc-price]');
        const moneyFormat = $productTemplate.dataset.moneyFormat || '{{amount}}';
        let quantity = 1;

        // Set a form field's value and notify any listeners (e.g. Shopify's
        // accelerated checkout button) that the form state has changed.
        function setFieldValue(input, value) {
            input.value = value;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Format a whole-currency-unit cents value using the shop's money_format,
        // mirroring the behaviour of Shopify's `money` liquid filter.
        function formatMoney(cents, format) {
            const centsNumber = Math.round(Number(cents) || 0);

            function withDelimiters(number, precision, thousands, decimal) {
                const fixed = (number / 100).toFixed(precision);
                const [whole, fraction] = fixed.split('.');
                const wholeWithThousands = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
                return fraction ? `${wholeWithThousands}${decimal}${fraction}` : wholeWithThousands;
            }

            const placeholder = format.match(/{{\s*(\w+)\s*}}/);
            let value;

            switch (placeholder && placeholder[1]) {
                case 'amount_no_decimals':
                    value = withDelimiters(centsNumber, 0, ',', '.');
                    break;
                case 'amount_with_comma_separator':
                    value = withDelimiters(centsNumber, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = withDelimiters(centsNumber, 0, '.', ',');
                    break;
                case 'amount_with_space_separator':
                    value = withDelimiters(centsNumber, 2, ' ', ',');
                    break;
                case 'amount_no_decimals_with_space_separator':
                    value = withDelimiters(centsNumber, 0, ' ', ',');
                    break;
                default:
                    value = withDelimiters(centsNumber, 2, ',', '.');
            }

            return format.replace(/{{\s*\w+\s*}}/, value);
        }

        if ($accordions){
            $accordions.forEach($currentAccordion => {
                $currentAccordion.addEventListener("click", () => {

                    $accordions.forEach($accordion => {
                        if ($accordion == $currentAccordion){
                            $currentAccordion.classList.toggle('active');
                        } else {
                            $accordion.classList.remove('active');
                        }
                    });
                });
            });
        }

        // Nutritional info modal
        const $nutritionalInfoTrigger = $productTemplate.querySelector('[data-nutritional-info-open]');
        const $nutritionalInfoModal = document.querySelector('[data-nutritional-info-modal]');

        if ($nutritionalInfoTrigger && $nutritionalInfoModal){
            // Move the modal to be a direct child of <body>. It's rendered nested inside
            // .product-template__container, which sets `z-2` and so creates its own stacking
            // context - the modal's z-index only wins against elements INSIDE that context, not
            // against later sibling sections on the page (e.g. Why Kidnetics), which is why it
            // could appear underneath them despite its own high z-index.
            if ($nutritionalInfoModal.parentElement !== document.body) {
                document.body.appendChild($nutritionalInfoModal);
            }

            const $nutritionalInfoCloseButtons = $nutritionalInfoModal.querySelectorAll('[data-nutritional-info-close]');

            $nutritionalInfoTrigger.addEventListener('click', () => {
                $nutritionalInfoModal.classList.remove('hidden');
                $nutritionalInfoModal.classList.add('flex');
                document.body.classList.add('overflow-hidden');
            });

            $nutritionalInfoCloseButtons.forEach($button => {
                $button.addEventListener('click', () => {
                    $nutritionalInfoModal.classList.add('hidden');
                    $nutritionalInfoModal.classList.remove('flex');
                    document.body.classList.remove('overflow-hidden');
                });
            });
        }

        // Variant buttons
        $productTemplate.querySelectorAll('.variant-option').forEach(button => {
            button.addEventListener('click', () => {
                $productTemplate.querySelectorAll('.variant-option').forEach(b => b.classList.remove('is-active'));
                button.classList.add('is-active');

                let currentVariantId = button.dataset.variantId;
                setFieldValue(variantInput, button.dataset.variantId);
                priceDisplay.textContent = button.dataset.price;
                subscriptionPriceDisplay.textContent = button.dataset.subscriptionPrice;

                const activeSubscription = $productTemplate.querySelector(
                'input[name="purchase_type"][value="subscription"]:checked'
                );

                if (activeSubscription) {
                    setFieldValue(sellingPlanInput, subscriptionFrequency.options[subscriptionFrequency.selectedIndex].getAttribute('plan_id'));
                }

                updateStickyAtcPrice();

                updateUrlState({
                    variantId: currentVariantId,
                    purchaseType: activeSubscription ? 'subscription' : 'otp'
                });
            });

        });

        // Add-to-cart button prices (main + sticky) follow the selected variant, purchase type & quantity
        function updateStickyAtcPrice() {
            const activeVariantButton = $productTemplate.querySelector('.variant-option.is-active');
            if (!activeVariantButton) return;

            const isSubscription = !!$productTemplate.querySelector(
                'input[name="purchase_type"][value="subscription"]:checked'
            );

            const unitPriceCents = isSubscription
                ? activeVariantButton.dataset.subscriptionPriceCents
                : activeVariantButton.dataset.priceCents;

            const totalPrice = formatMoney(unitPriceCents * quantity, moneyFormat);

            if (stickyAtcPrice) stickyAtcPrice.textContent = totalPrice;
            if (atcPrice) atcPrice.textContent = totalPrice;
        }

        // Variant button prices follow the selected purchase type
        function updateVariantPrices() {
            const isSubscription = !!$productTemplate.querySelector(
                'input[name="purchase_type"][value="subscription"]:checked'
            );

            $productTemplate.querySelectorAll('.variant-option').forEach(button => {
                const priceText = button.querySelector('[data-price-text]');
                if (priceText) {
                    priceText.textContent = isSubscription
                        ? button.dataset.subscriptionPrice
                        : button.dataset.price;
                }

                const pricePerBallText = button.querySelector('[data-price-per-ball-text]');
                if (pricePerBallText) {
                    pricePerBallText.textContent = isSubscription
                        ? button.dataset.subscriptionPricePerBall
                        : button.dataset.pricePerBall;
                }
            });
        }

        // Purchase options
        purchaseRadios.forEach(radio => {
            radio.addEventListener('change', () => {
                $productTemplate.querySelectorAll('.purchase-option').forEach(option =>
                    option.classList.remove('is-active')
                );

                radio.closest('.purchase-option').classList.add('is-active');

                if (radio.value === 'subscription') {
                    setFieldValue(sellingPlanInput, subscriptionFrequency.options[subscriptionFrequency.selectedIndex].getAttribute('plan_id'));
                } else {
                    setFieldValue(sellingPlanInput, '');
                }

                updateVariantPrices();
                updateStickyAtcPrice();

                updateUrlState({
                    variantId: variantInput.value,
                    purchaseType: radio.value
                });

            });
        });

        // Sticky mobile ATC banner: show whenever the main add-to-cart row is off screen
        if (stickyAtc && atcRow) {
            const stickyAtcObserver = new IntersectionObserver(([entry]) => {
                stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
            });

            stickyAtcObserver.observe(atcRow);
        }

        // Sticky mobile ATC button triggers the same add to cart action
        if (stickyAtcButton) {
            stickyAtcButton.addEventListener("click", () => {
                addProductToCart(variantInput.value, qtyInput.value, sellingPlanInput.value, true)
            });
        }

        // Subscription frequency
        if (subscriptionFrequency){
            subscriptionFrequency.addEventListener("change", () => {
                const selectedFrequency = subscriptionFrequency.value;
                const frequencyId = subscriptionFrequency.options[subscriptionFrequency.selectedIndex].getAttribute('plan_id');
                setFieldValue(sellingPlanInput, frequencyId);
            });
        }

        // Add to cart
        if (addToCartTrigger){
            addToCartTrigger.addEventListener("click", () => {
                addProductToCart(variantInput.value, qtyInput.value, sellingPlanInput.value, true)
            });
        }

        // Quantity controls
        $productTemplate.querySelector('[data-qty-plus]').addEventListener('click', () => {
            quantity++;
            setFieldValue(qtyInput, quantity);
            qtyDisplay.textContent = quantity;
            updateStickyAtcPrice();
        });

        $productTemplate.querySelector('[data-qty-minus]').addEventListener('click', () => {
            if (quantity <= 1) return;
            quantity--;
            setFieldValue(qtyInput, quantity);
            qtyDisplay.textContent = quantity;
            updateStickyAtcPrice();
        });

        // Update url on variant & purchase type selection
        function updateUrlState({ variantId, purchaseType }) {
            const params = new URLSearchParams(window.location.search);

            if (variantId) {
                params.set('variant', variantId);
            }

            if (purchaseType) {
                params.set('purchase-type', purchaseType);
            }

            const newUrl = `${window.location.pathname}?${params.toString()}`;
            window.history.replaceState({}, '', newUrl);
        }

        // Get url parameters
        function getInitialStateFromUrl() {
            const params = new URLSearchParams(window.location.search);

            return {
                variantId: params.get('variant'),
                purchaseType: params.get('purchase-type')
            };
        }

        // Apply selection from url parameters
        function applyInitialState() {
            const { variantId, purchaseType } = getInitialStateFromUrl();

            // Variant
            if (variantId) {
                const variantButton = document.querySelector(
                `.variant-option[data-variant-id="${variantId}"]`
                );

                if (variantButton) {
                 variantButton.click();
                }
            }

            // Purchase type
            if (purchaseType === 'subscription') {
                const subscriptionInput = document.querySelector(
                'input[name="purchase_type"][value="subscription"]'
                );

                if (subscriptionInput) {
                    subscriptionInput.click();
                }
            } else if (purchaseType === 'otp') {
                const onetimeInput = document.querySelector(
                'input[name="purchase_type"][value="otp"]'
                );

                if (onetimeInput) {
                    onetimeInput.click();
                }
            }

            if (!variantId && !purchaseType){
                const defualtVariant = document.querySelector(".default-variant");
                
                if (defualtVariant){
                    defualtVariant.click();
                }
            }
        }

        // Check for any url parameters on page load
        applyInitialState();
        updateVariantPrices();
        updateStickyAtcPrice();
    }

    /*------------------
    Cart
    -------------------*/
    const $flyoutCart = document.querySelector('.flyout-cart');

    if ($flyoutCart){

        InitialiseCart($flyoutCart);
    }   

    // Initialise cart
    function InitialiseCart(cart){
        // line items
        const $lineItems = cart.querySelectorAll(".cart-item");
        const $checkout = cart.querySelector(".flyout-cart__checkout");
        
        // close/open toggles
        const $open = document.querySelector(".header-cart");
        const $close = document.querySelectorAll(".flyout-cart__close");

        // upsell items
        const $upsellItems = cart.querySelectorAll(".upsell-item");

        $open?.addEventListener("click", () => {
            cart.classList.add('open');
        });

        $close.forEach($trigger => {
            $trigger?.addEventListener("click", () => {
                cart.classList.remove('open');
            });
        });

        // attach event listeners to cart line items
        $lineItems.forEach($item => {
            const $increaseQty = $item.querySelector(".cart-item__quantity-increase");
            const $decreaseQty = $item.querySelector(".cart-item__quantity-decrease");
            const $removeItem = $item.querySelector(".cart-item__remove");

            $increaseQty.addEventListener("click", () => {
                let newQuantity = parseInt($item.dataset.quantity);
                newQuantity++;

                updateCartItem($item.dataset.key, newQuantity);
            });

            $decreaseQty.addEventListener("click", () => {
                let newQuantity = parseInt($item.dataset.quantity);
                newQuantity--;

                updateCartItem($item.dataset.key, newQuantity);
            });

            $removeItem.addEventListener("click", () => {
                updateCartItem($item.dataset.key, 0);
            });
        });

        // attach event listener to checkout button
        $checkout.addEventListener("click", () => {
            window.location.href = '/checkout';
        });

        // attach event listener to upsell
        if ($upsellItems){
            $upsellItems.forEach($item => {
                const $addToCart = $item.querySelector(".upsell-item__add");

                if ($addToCart){
                    $addToCart.addEventListener("click", () => {
                        addProductToCart($item.dataset.id, 1);
                    });
                }
            });
        }
    }

    async function ReRenderCart() {
        const cart = document.querySelector('.flyout-cart');
        const headerCart = document.querySelector('.header-section');

        if (!cart && !headerCart) return;

        const sectionIds = [];

        if (cart) sectionIds.push(cart.dataset.sectionId);
        if (headerCart) sectionIds.push(headerCart.dataset.sectionId);

        try {
            const response = await fetch(`/?sections=${sectionIds.join(',')}`);
            const sections = await response.json();

            // --- Update flyout cart parts ---
            if (cart) {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = sections[cart.dataset.sectionId];

                [
                    'flyout-cart__header',
                    'flyout-cart__body',
                    'flyout-cart__upsell',
                    'flyout-cart__footer'
                ].forEach(className => {
                    const current = cart.querySelector(`.${className}`);
                    const fresh = tempDiv.querySelector(`.${className}`);
                    if (current && fresh) {
                        current.innerHTML = fresh.innerHTML;
                    }
                });

                InitialiseCart(cart);
            }

            // --- Update header cart badge ---
            if (headerCart) {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = sections[headerCart.dataset.sectionId];

                const currentWrapper = document.querySelector('.header-cart__wrapper');
                const newWrapper = tempDiv.querySelector('.header-cart__wrapper');

                if (!currentWrapper || !newWrapper) return;

                const currentBadge = currentWrapper.querySelector('.header-cart__badge');
                const newBadge = newWrapper.querySelector('.header-cart__badge');

                // Badge should exist
                if (newBadge) {
                    if (currentBadge) {
                        currentBadge.innerHTML = newBadge.innerHTML;
                    } else {
                        currentWrapper.appendChild(newBadge.cloneNode(true));
                    }
                }

                // Badge should NOT exist
                if (!newBadge && currentBadge) {
                    currentBadge.remove();
                }
            }




        } catch (error) {
            console.error('Cart/header re-render failed:', error);
        }
    }

    function openFlyoutCart(){
        $flyoutCart?.classList.add('open');
    }

    // Update cart item
    async function updateCartItem(key, quantity){
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                id: key,
                quantity: quantity
            })
        });

        if (response.ok) {
            ReRenderCart();
        }
    }

    // Add to cart
    async function addProductToCart(id, quantity, selling_plan, openCart) {

        const payload = {
            id: id,
            quantity: quantity
        };

        // Only include selling_plan if it exists
        if (selling_plan) {
            payload.selling_plan = selling_plan;
        }

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error('Add to cart failed');
            }

            await ReRenderCart();
            openFlyoutCart();

        } catch (error) {
            console.error(error);
        }
    }

    
    /* Helper functions */
    const $scrollToTriggers = document.querySelectorAll(".scroll-to-trigger");

    if ($scrollToTriggers){
        $scrollToTriggers.forEach($trigger => {
            $trigger.addEventListener("click", () => {
                const $target = document.getElementById($trigger.dataset.target);
                
                if ($target){
                    const y = $target.getBoundingClientRect().top + window.pageYOffset;

                    window.scrollTo({
                        top: y,
                        behavior: "smooth"
                    });
                }
            });
        });
    }
    /*------------------
    FAQ Section
    -------------------*/
    const $faqSections = document.querySelectorAll('.faq-section');
    
    if ($faqSections){
        $faqSections.forEach($section => {
            $section.addEventListener('click', () => {
                const $faqs = $section.querySelectorAll('.faq');

                $faqs.forEach($faq => {
                    $faq.addEventListener('click', e => {

                        $faqs.forEach($item => {
                            if ($item === $faq){
                                $faq.classList.toggle('active');
                            } else {
                                $item.classList.remove('active');
                            }
                        });
                    });
                });
            });
            
        });
    }


        //------------------ Testimonials ------------------//
    const $landingswipers = document.querySelector(".landingswipers-section");

    if ($landingswipers){
        const slides = Array.from(document.querySelectorAll(".landingswipers-slide"));
        const triggers = Array.from(document.querySelectorAll(".landingswipers-section-trigger"));

        const prevBtn = document.querySelectorAll(".landingswiper-swiper___prev");
        const nextBtn = document.querySelectorAll(".landingswiper-swiper___next");

        if (!slides.length || !triggers.length) return;

        let current = 0; // starting index

        function showSlide(index) {
            current = index;

            slides.forEach((slide, i) => {
                slide.classList.toggle("active", i === current);
            });

            triggers.forEach((trigger, i) => {
                trigger.classList.toggle("active", i === current);
            });
        }

        // Trigger click events
        triggers.forEach((trigger, index) => {
            trigger.addEventListener("click", () => {
            showSlide(index);
            });
        });

        // Prev / Next logic
        prevBtn.forEach(button => {
            button?.addEventListener("click", () => {
                const newIndex = (current - 1 + slides.length) % slides.length;
                showSlide(newIndex);
            });
        });

        nextBtn.forEach(button => {
            button?.addEventListener("click", () => {
                const newIndex = (current + 1) % slides.length;
                showSlide(newIndex);
            });
            
        });

        // Initialize
        showSlide(0);
    }
});


